import React from 'react';

const MissionSection = () => {
  return (
    <div className="bg-gradient-to-r from-blue-600 to-cyan-600 rounded-2xl p-8 text-white text-center" data-aos="fade-left">
      <h2 className="text-2xl font-bold mb-4">Our Mission</h2>
      <p className="text-lg text-blue-100 leading-relaxed">
        To make UK immigration accessible, transparent, and successful for every client through expert guidance, 
        personalized solutions, and unwavering commitment to excellence. We believe in transforming immigration 
        dreams into reality with integrity, empathy, and professional excellence.
      </p>
    </div>
  );
};

export default MissionSection;